import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../../components/common/HowItWorksModal/howItWorksModal.css";

const EmptyContentModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="how-it-works-modal">
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>Cannot Save Empty Content</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-2">
          <p className="mb-2">The disclaimer text cannot be empty.</p>
          <p className="mb-0">
            If you want to hide this section, please use the 'Hide from Reports'
            button instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Back to Edit
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default EmptyContentModal;
